import { Cache } from './CachingContext';

export enum CacheOptions {
  SET_STATE = 'SET_STATE',
  CLEAR_STATE = 'CLEAR_STATE',
}

const localStorageAllowed = ['requestid', 'my', 'organisationsapplicationsguid'];

export const reducer = (
  prevState: Cache,
  action: { type: CacheOptions; payload: Cache | string | undefined },
): Cache => {
  switch (action.type) {
    case CacheOptions.SET_STATE: {
      const localState: Cache = {};
      const sessionState: Cache = {};

      const newState = {
        ...prevState,
        ...(action.payload as Cache),
      };

      Object.keys(newState).some((p) => {
        if (localStorageAllowed.includes(p)) {
          localState[p] = newState[p];
        } else {
          sessionState[p] = newState[p];
        }
      });

      sessionStorage.setItem('cache', JSON.stringify(sessionState));
      localStorage.setItem('cache', JSON.stringify(localState));
      return { ...sessionState, ...localState };
    }
    case CacheOptions.CLEAR_STATE:
      const newState = { ...prevState };

      if (action.payload) {
        delete newState[action.payload as string];

        if (localStorageAllowed.includes(action.payload as string)) {
          const currentStorage = JSON.parse(localStorage.getItem('cache') || '{}');
          delete currentStorage[action.payload as string];
          localStorage.setItem('cache', JSON.stringify(currentStorage));
        } else {
          const currentStorage = JSON.parse(sessionStorage.getItem('cache') || '{}');
          delete currentStorage[action.payload as string];
          sessionStorage.setItem('cache', JSON.stringify(currentStorage));
        }

        return newState;
      } else {
        sessionStorage.removeItem('cache');
        localStorage.removeItem('cache');
        return {};
      }
    default:
      return prevState;
  }
};
